<template>
    <b-row class="justify-content-md-center">
      <b-col>
        <div class="spinner-item">
          <rotate-square4></rotate-square4>
        </div>
      </b-col>
    </b-row>
</template>

<script>
import { RotateSquare4 } from "vue-loading-spinner";

export default {
  name: "Spinner",
  data: function() {
    return { };
  },
  created: function() {
  },
  components: { RotateSquare4 }
};
</script>

<style lang="css" scoped>
.spinner {
  border: 4px solid #1288b4;
}
.spinner-item {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: transparent;
  background-clip: border-box;
  align-items: center;
}
.spinner >>> .loader-inner {
  background-color: #1288b4 !important;
  width: 5%;
  margin-left: 3px;
}
</style>
